import _ from "lodash";
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Button,
  IconButton,
  SelectDropdown,
  TextInput,
  Dropdown,
  DropdownMenu,
  ToggleSwitch,
  Tooltip,
  Modal,
  Alert,
  Checkbox,
} from "@toddle-edu/ds-web";
import {
  AddOutlined,
  DeleteOutlined,
  TickCircleFilled,
  DotsVerticalOutlined,
  InformationFilled,
  ArrowOutOutlined,
  AddCircleOutlined,
} from "@toddle-edu/ds-icons";

import classes from "./CreateTemplate.scss";
import ColorSelector from "UIComponents/ColorSelector";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import SelectDropdownButton from "UIComponents/SelectDropdownButton";
import AssessmentIcon from "UIComponents/AssessmentIcon";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import { useI18n } from "Hooks";
import {
  checkTotalPercentageWeight,
  checkTotalPercentageWeightError,
  getHierarchy,
  getHierarchyRoute,
  getCourseOptionsMemoize,
  getGradesOptionsMemoize,
  getSelectedGradesMemoize,
  colorPalletOptions,
  getIsCategorySetUpdated,
  getIsCategorySetNotEmpty,
  getUsedCoursesAndCategorySetNames,
  getAssignmentsWithAutoEvaluateTool,
} from "ScoreCategories/modules/ScoreCategoriesModule";
import {
  getOptionsWithIcon,
  getAbsolutePercentageValueMemoize,
} from "ScoreCategories/modules/Utils";
import {
  getCategoryGradeBoundaryToggleLabel,
  getCategoryGradeBoundaryToggleTooltip,
} from "GradingSetup/modules/Utils";
import BreadCrumbs from "AppComponents/BreadCrumbs";
import { colors } from "@toddle-edu/ds-theme";
import classNames from "classnames";
import CategoryGradeBoundary from "ScoreCategories/components/CategoryGradeBoundary";
import CategoryGradeScale from "ScoreCategories/components/CategoryGradeScale";
import {
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_UBD,
  SCORE,
} from "Constants/stringConstants";
import { getIsScoreV2 } from "routes/routes/Administrator/routes/DPAcademicSetup/routes/AssessmentSetup/modules/utils";
import { getAssessmentObj } from "ClassRoom/modules/ClassRoomModule";
import { openLinkInNewTab } from "modules/Services";
import { Trans } from "react-i18next";
import AssessmentCategoriesDeleteModal from "ScoreCategories/components/AssessmentCategoriesDeleteModal";
import ResetOverridenCategoryScoreWarningModal from "GradingSetup/routes/AssessmentCategorySetup/components/AssessmentCategorySetupConfiguration/ResetOverridenCategoryScoreWarningModal";
import { DOUBLE_DIGIT_DECIMAL_NUMBERS_REGEX } from "Constants";

const styles = {
  subTextStyle: {
    marginTop: "4px",
  },
  containerStyle: {
    marginBottom: "48px",
  },
  buttonStyle: {
    marginRight: "24px",
    marginLeft: "24px",
  },
  textInputStyle: {
    width: "40%",
  },
  textInputContainerStyle: {
    height: "40px",
  },
  tooltipStyle: {
    width: "312px",
  },
  dropdownParentContainer: {
    width: "100%",
  },
  colorPalletButtonContainer: {
    width: "100%",
  },
  addCategoryButton: {
    textDecorationLine: "none",
  },
  buttonComponentStyle: {
    paddingLeft: "14px",
  },
};

const DIALOGS_INFO = {
  DELETE: {
    title: ({ t, currentDialogueInfo }) =>
      t("academicSetup:delete_grade_boundary_with_label", {
        label: currentDialogueInfo?.params?.label,
      }),
    body: ({
      t,
      currentDialogueInfo,
      setCurrentDialogueInfo,
      curriculumProgramId,
      curriculumType,
      openLinkInNewTab,
      getAssessmentObj,
    }) => {
      const { assignmentsWithIBGradeTool = [], label } =
        currentDialogueInfo?.params || {};

      const navigateToAssignment = ({ assignmentId, courseId }) => {
        if (assignmentId && courseId) {
          const url = `/platform/${curriculumProgramId}/courses/${courseId}/classroom/classroom-details/${assignmentId}/allsubmissions`;
          openLinkInNewTab({ url });
        }
      };

      const boundaryHasTools = !_.isEmpty(assignmentsWithIBGradeTool);

      let message = "";

      if (boundaryHasTools) {
        const label = _.size(assignmentsWithIBGradeTool);
        message = (
          <Trans i18nKey="academicSetup:delete_category_boundary_with_tool_warning_msg">
            <span className={classes.span}>
              This grade boundary has been used in
            </span>
            <span className={classes.demiBoldLabel}>
              {{ label }} assessment(s)
            </span>
            <span className={classes.span}>
              in the automated IB grade scale. Please edit those assessments in
              order to delete this grade boundary.
            </span>
          </Trans>
        );
      } else {
        message = (
          <Trans i18nKey="academicSetup:delete_category_boundary_without_tool_warning_msg_gradebook">
            <span className={classes.span}>
              Deleting the grade boundary defined for ‘{{ label }}’ will
            </span>
            <span className={classes.boldLabel}>remove</span>
            <span className={classes.span}>
              the IB grades for ‘{{ label }}’ from the gradebook and unlocked
              progress reports. Would you like to proceed?
            </span>
          </Trans>
        );
      }
      return (
        <div className={classes.modalBodyContainer}>
          <Alert message={message} type="warning" />

          {boundaryHasTools ? (
            <div className={classes.assignmentsContainer}>
              {_.map(assignmentsWithIBGradeTool, ({ node }) => {
                const content = _.get(node, "content", {});

                const assessmentValue = _.get(content, "assessmentType.value");
                const image = _.get(content, "image.value");

                const courseId = _.get(node, "course.id");

                const typeObj = getAssessmentObj({
                  curriculumType,
                  assessmentValue,
                  contentType: node?.contentType,
                });
                const { typeLabel, typeLabel2 } = typeObj || {};

                const title =
                  _.get(content, "title.value") || t("common:untitled");

                return (
                  <div className={classes.assignmentCard}>
                    <div className={classes.leftContainer}>
                      <AssessmentIcon
                        src={image}
                        assessmentType={assessmentValue}
                        contentType={node?.contentType}
                        className={classes.avatar}
                      />
                      <div className={classes.assignmentInfoContainer}>
                        <div className={classes.title}>{title}</div>
                        <div className={classes.subtitle}>
                          {t(typeLabel2 || typeLabel)}
                        </div>
                      </div>
                    </div>
                    <div className={classes.arrowIconButton}>
                      <IconButton
                        size={"medium"}
                        _legacy_variant={"plain"}
                        variant="neutral"
                        type="plain"
                        icon={<ArrowOutOutlined variant="subtle" />}
                        onClick={() =>
                          navigateToAssignment({
                            assignmentId: node?.id,
                            courseId,
                          })
                        }
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div
              className={classes.alertWithCheckboxContainer}
              onClick={() => {
                setCurrentDialogueInfo(prevState => {
                  return {
                    ...prevState,
                    params: {
                      ..._.get(prevState, "params", {}),
                      isChecked: !prevState?.params?.isChecked,
                    },
                  };
                });
              }}
            >
              <Checkbox isChecked={currentDialogueInfo?.params?.isChecked} />

              <span className={classes.span}>
                {t("classRoom:i_understand_and_would_still_like_to_proceed")}
              </span>
            </div>
          )}
        </div>
      );
    },
    confirmButtonText: ({ t }) => t("common:delete"),
    cancelButtonText: ({ t }) => t("common:cancel"),
    disableConfirmButton: ({ currentDialogueInfo }) => {
      const { assignmentsWithIBGradeTool = [], isChecked = false } =
        currentDialogueInfo?.params || {};
      return _.size(assignmentsWithIBGradeTool) > 0 || !isChecked;
    },
  },
};

const CreateTemplate = props => {
  const {
    isEditMode,
    templateFieldsObj,
    addTemplateFieldValue,
    deleteTemplateFieldValue,
    updateTemplateFieldsSet,
    updateTemplateField,
    onClickDeleteTemplate,
    onClickSave,
    isLoading,
    usedCourses,
    setUsedCourses,
    organizationPointSet,
    termId,
    subjectId,
    subjectName,
    goToRelativeRoute,
    areNotValid,
    setAreNotValid,
    curriculumType,
    setUsedCategorySetNames,
    subjectBasedCourses,
    grades,
    subject,
    isCourseApplicableToCategorySet,
    curriculumProgramId,
    curriculumProgramTitle,
    isAbsoluteWeightageType,
    subjectLevelGenericTags,
    setShowDialogueBox,
    setCurrentDialogueAction,
    pointSetVariables,
    openLinkInNewTab,
    isClassSettingsContext = false,
    setClassSettingMode,
    selectedGrade,
    getAssignmentsWithAutoEvaluateTool,
    alertText,
    isNewAssessmentSettingsEnabled,
    defaultGradeScaleSet,
    isWeightageEnabledForCategory,
    canDefineGradeBoundary,
    finalGradeCalculationMethod,
    showCategoryGradeBoundaryToggle,
    isAdmin,
    gradeCalculationMethod,
    currentCategoryGradeBoundaryValues,
    overallCategoryGradeBoundaryValues,
    updateCurrentCategoryGradeBoundaryValues,
    updateOverallCategoryGradeBoundaryValues,
    portalType,
    categoryTotalDisplayType,
    templateId,
    getAssessmentObj,
    onCloseModal,
    onClickSaveHandler,
    overriddenCategories,
    handleSave,
    headerText,
    bodyText,
    checkboxText,
    showUpdatedDesign = false,
  } = props;

  const dsVersion = showUpdatedDesign ? "2.0" : "1.0";

  const subjectType = _.get(subject, "type");

  const { t } = useI18n([
    "common",
    "classRoom",
    "teacherHomePage",
    "academicSetup",
    "schoolSetup",
  ]);
  const {
    label,
    isShowGradeBoundaries,
    courses,
    fieldValues,
  } = templateFieldsObj;

  const fieldValuesLength = _.get(fieldValues, "length", 0);
  const [totalPercentageWeight, setTotalPercentageWeight] = useState({
    percentage_weight: 0,
    slWeight: 0,
    hlWeight: 0,
  });
  const [deleteCategoryConfirmation, setDeleteCategoryConfirmation] = useState(
    {}
  );
  const [isTemplateUpdated, setIsTemplateUpdated] = useState(false);
  const [modalParams, setModalParams] = useState({});
  const [currentDialogueInfo, setCurrentDialogueInfo] = useState({
    action: "",
    params: {},
  });

  useEffect(() => {
    const {
      usedCourses,
      usedCategorySetNames,
    } = getUsedCoursesAndCategorySetNames({
      organizationPointSet,
      templateFieldsObj,
      isCourseApplicableToCategorySet,
    });

    //Array of class ids which are associated with an existing category set
    const disabledCourses = _.difference(usedCourses, courses);
    setUsedCategorySetNames(usedCategorySetNames);
    setUsedCourses(disabledCourses);
    isClassSettingsContext && !isEditMode
      ? updateSelectedGrades(selectedGrade)
      : null;
    return () => {
      updateOverallCategoryGradeBoundaryValues({});
    };
  }, []);

  useEffect(() => {
    if (curriculumType === "IB_DP" && !_.isEmpty(subjectLevelGenericTags)) {
      const totalslWeight = checkTotalPercentageWeight({
        templateFieldsObj,
        weightKey: "slWeight",
      });
      const totalhlWeight = checkTotalPercentageWeight({
        templateFieldsObj,
        weightKey: "hlWeight",
      });
      setTotalPercentageWeight({
        ...totalPercentageWeight,
        slWeight: totalslWeight,
        hlWeight: totalhlWeight,
      });
    } else {
      const totalWeight = checkTotalPercentageWeight({
        templateFieldsObj,
        weightKey: "percentage_weight",
      });
      setTotalPercentageWeight({
        ...totalPercentageWeight,
        percentage_weight: totalWeight,
      });
    }
  }, [fieldValues]);

  useEffect(() => {
    setIsTemplateUpdated(
      getIsCategorySetUpdated({
        pointSetVariables,
        templateFieldsObj,
        isCourseApplicableToCategorySet,
      })
    );
  }, [templateFieldsObj]);

  const isCurriculumDP = _.isEqual(curriculumType, CURRICULUM_TYPE_DP);
  const isCurriculumMYP = _.isEqual(curriculumType, CURRICULUM_TYPE_MYP);
  const isCurriculumUBD = _.isEqual(curriculumType, CURRICULUM_TYPE_UBD);
  const isScoreV2 = getIsScoreV2({ curriculumType });

  const onCancel = () => {
    setAreNotValid({});
    if (isScoreV2) {
      let shouldShowDialogue = false;
      if (_.get(templateFieldsObj, "id")) {
        if (isTemplateUpdated) {
          shouldShowDialogue = true;
        }
      } else if (getIsCategorySetNotEmpty({ templateFieldsObj })) {
        shouldShowDialogue = true;
      }
      if (shouldShowDialogue) {
        if (isClassSettingsContext) {
          setClassSettingMode({
            isEditing: false,
            assessmentCategoryId: "",
          });
        }
        setCurrentDialogueAction?.({
          action: "DISCARD",
          params: {},
        });
        return;
      }
    }
    if (isClassSettingsContext) {
      setClassSettingMode({
        isEditing: false,
        assessmentCategoryId: "",
      });
    } else {
      goToRelativeRoute({
        route: "../",
      });
    }
  };

  const renderHeadingRightContainer = (
    <div className={classes.buttonContainer}>
      {isEditMode && !isClassSettingsContext ? (
        <IconButton
          icon={<DeleteOutlined variant={"critical"} />}
          onClick={() => {
            setShowDialogueBox(true);
          }}
          _legacy_variant="plain"
          variant="neutral"
          type="outlined"
          _legacy_size="large"
          size="medium"
          style={{ borderColor: colors.borderDefault, borderWidth: "1px" }}
        />
      ) : null}
      {!_.isEmpty(overriddenCategories) ? (
        <ResetOverridenCategoryScoreWarningModal
          headerText={headerText}
          bodyText={bodyText}
          checkboxText={checkboxText}
          onClose={onCloseModal}
          onSubmit={handleSave}
        />
      ) : null}
      <Button
        _legacy_size="large"
        size="medium"
        _legacy_variant="outlined-subtle"
        variant="neutral"
        type="outlined"
        style={styles.buttonStyle}
        onClick={onCancel}
      >
        {t("common:cancel")}
      </Button>
      <Button
        _legacy_size="large"
        size="medium"
        variant="progressive"
        onClick={onClickSaveHandler}
        disabled={isEditMode && !isTemplateUpdated}
      >
        {t("common:save")}
      </Button>
    </div>
  );

  const rightContainerClass = classNames({
    [classes.rightContainer]: true,
    [classes.rightContainerForIBGradeCalculationType]:
      !isWeightageEnabledForCategory && !canDefineGradeBoundary,
    [classes.rightContainerForScoreCalculationType]: isNewAssessmentSettingsEnabled,
  });
  const categoryNameContainerClass = classNames({
    [classes.categoryNameContainer]: !showUpdatedDesign,
    [classes.categoryNameContainerForScoreCalculationType]:
      !showUpdatedDesign && isNewAssessmentSettingsEnabled,
    [classes.categoryNameContainerV2]: showUpdatedDesign,
  });
  const percentageWeightContainerClass = classNames({
    [classes.percentageWeight]: !showUpdatedDesign,
    [classes.percentageWeightForScoreCalculationType]:
      !showUpdatedDesign && isNewAssessmentSettingsEnabled,
    [classes.percentageWeightV2]: showUpdatedDesign,
  });

  const categoryTemplateDataCellClasses = classNames({
    [classes.categoryTemplateDataCell]: !showUpdatedDesign,
    [classes.categoryTemplateDataCellV2]: showUpdatedDesign,
  });

  const percentageWeightInputClasses = classNames({
    [classes.percentageWeightInput]: !showUpdatedDesign,
    [classes.percentageWeightInputV2]: showUpdatedDesign,
  });

  const categoryColorClasses = classNames({
    [classes.categoryColor]: !showUpdatedDesign,
    [classes.categoryColorV2]: showUpdatedDesign,
  });

  const categoryNameClasses = classNames({
    [classes.categoryName]: !showUpdatedDesign,
    [classes.categoryNameV2]: showUpdatedDesign,
  });

  const gradeBoundaryBtnClasses = classNames({
    [classes.gradeBoundaryBtn]: showUpdatedDesign,
  });

  const deleteBtnClasses = classNames({
    [classes.deleteBtn]: showUpdatedDesign,
  });

  const gradeBoundaryAddedClasses = classNames({
    [classes.gradeBoundaryAdded]: !showUpdatedDesign,
    [classes.gradeBoundaryAddedV2]: showUpdatedDesign,
  });

  const renderCategoryInput = ({ fieldValue, index, isLastCategory }) => {
    const categoryId = _.get(fieldValue, "id", "");
    const label = _.get(fieldValue, "label", "");
    const percentage_weight = _.get(fieldValue, "percentage_weight", "");
    const color = _.get(fieldValue, "color", "");
    const slWeight = _.toString(_.get(fieldValue, "slWeight", ""));
    const hlWeight = _.toString(_.get(fieldValue, "hlWeight", ""));
    const gradeBoundaryId = _.get(fieldValue, "gradeBoundaryId");
    const gradeScaleType = _.get(fieldValue, "gradeScaleType");

    const hasPercentageWeight = _.parseInt(percentage_weight) > 0;
    let hasSLWeight = false;
    let hasHLWeight = false;
    _.forEach(subjectLevelGenericTags, tag => {
      const tagLabel = _.get(tag, "label");
      if (
        _.isEqual(tagLabel, "SL") &&
        (!isWeightageEnabledForCategory || _.parseInt(slWeight) > 0)
      ) {
        hasSLWeight = true;
      } else if (!isWeightageEnabledForCategory || _.parseInt(hlWeight) > 0) {
        hasHLWeight = true;
      }
    });

    const skipGradeScaleButtonDisableCheck =
      !isWeightageEnabledForCategory && canDefineGradeBoundary;
    let addGradeScaleBtnDisabled = false;

    if (!skipGradeScaleButtonDisableCheck) {
      addGradeScaleBtnDisabled =
        _.isEmpty(subjectLevelGenericTags) && !hasPercentageWeight;

      _.forEach(subjectLevelGenericTags, tag => {
        const tagLabel = _.get(tag, "label");
        if (!hasSLWeight && !hasHLWeight) {
          addGradeScaleBtnDisabled = true;
          return false;
        } else if (
          (_.isEqual(tagLabel, "SL") && _.isEmpty(slWeight)) ||
          (_.isEqual(tagLabel, "HL") && _.isEmpty(hlWeight))
        ) {
          addGradeScaleBtnDisabled = true;
        }
      });
    }
    const onClickDelete = () => {
      if (isEditMode) {
        setDeleteCategoryConfirmation({
          categoryId,
          index,
          label,
        });
      } else {
        deleteTemplateFieldValue({ index });
      }
    };

    const updateGradeBoundaryId = id => {
      updateTemplateField({
        params: { gradeBoundaryId: id },
        index,
      });
    };

    const mapCategoryWithGradeBoundary = id => {
      updateGradeBoundaryId(id);
    };

    const onUpdateGradeScaleBoundary = params => {
      updateTemplateField({
        params,
        index,
      });
    };

    const onClickDropdownMenu = async ({ action, modalParams }) => {
      switch (action) {
        case "edit":
          setModalParams(modalParams);
          break;
        case "delete": {
          if (isCurriculumDP) {
            const queryData = await getAssignmentsWithAutoEvaluateTool();
            const assignments = _.get(queryData, "assignments.edges", []);

            const assignmentsWithIBGradeTool = _.filter(
              assignments,
              ({ node }) => {
                const assessmentTool = _.get(
                  node,
                  "content.assessmentTools.edges.0.node"
                );
                const assessmentToolId = _.get(
                  assessmentTool,
                  "assessmentToolItem.id"
                );

                return assessmentToolId == gradeBoundaryId;
              }
            );

            const onClickDelete = async () => {
              const response = await onClickDeleteTemplate({
                templateId: gradeBoundaryId,
                isGradeBoundary: true,
              });
              if (_.get(response, "success")) {
                updateGradeBoundaryId(null);
              }
            };

            setCurrentDialogueInfo({
              action: "DELETE",
              params: {
                templateId: gradeBoundaryId,
                isGradeBoundary: true,
                assignmentsWithIBGradeTool,
                label: modalParams?.label,
                onClickDelete,
              },
            });
          } else {
            let isSuccessful = true;
            if (gradeBoundaryId) {
              const response = await onClickDeleteTemplate({
                templateId: gradeBoundaryId,
                isGradeBoundary: true,
              });
              isSuccessful = _.get(response, "success");
            }
            if (isSuccessful) {
              onUpdateGradeScaleBoundary({
                gradeBoundaryId: null,
                gradeScaleType: null,
              });
            }
          }
          break;
        }
        default:
          return;
      }
    };

    const addedTextClass = classNames({
      [classes.addedText]: !showUpdatedDesign,
      ["text-body-1"]: !showUpdatedDesign,
      [classes.addedTextV2]: showUpdatedDesign,
      ["text-label"]: showUpdatedDesign,
    });
    const dropdownOptions = getOptionsWithIcon(t);

    const updateWeight = (field, e) => {
      const weight = _.get(e, "target.value", "");

      // allow only numbers and upto 2 decimals
      if (!DOUBLE_DIGIT_DECIMAL_NUMBERS_REGEX.test(weight) && weight) return;

      updateTemplateField({
        params: {
          [field]: weight,
        },
        index,
      });
    };

    const modalParamsObj = {
      index,
      label,
      categoryId,
      gradeBoundaryId,
      hasSLWeight,
      hasHLWeight,
      prevGradeScaleType: gradeScaleType,
      onUpdateGradeScaleBoundary,
      mapCategoryWithGradeBoundary,
    };

    const openModal = () => {
      setModalParams(modalParamsObj);
    };

    return (
      <div className={categoryTemplateDataCellClasses}>
        <div className={categoryNameContainerClass}>
          <div className={categoryNameClasses}>
            <TextInput
              placeholder={t("academicSetup:enter_category_name")}
              value={label}
              required={true}
              onChange={e =>
                updateTemplateField({
                  params: { label: e.target.value },
                  index,
                })
              }
              error={_.get(areNotValid, `label_${index}`, false) && !label}
              autoFocus={isLastCategory && !label}
              dsVersion={dsVersion}
            />
          </div>
          <div className={categoryColorClasses}>
            <ColorSelector
              name="color"
              value={color}
              options={colorPalletOptions}
              updateInputField={params =>
                updateTemplateField({ params, index })
              }
              dropdownParentContainerStyle={styles.dropdownParentContainer}
              colorPalletButtonContainerStyle={
                styles.colorPalletButtonContainer
              }
              colorDropSize={showUpdatedDesign ? "20px" : "24px"}
              buttonComponentStyle={
                showUpdatedDesign ? styles.buttonComponentStyle : {}
              }
            />
          </div>
        </div>
        <div className={rightContainerClass}>
          <div className={classes.inputTextContainer}>
            {isWeightageEnabledForCategory &&
              (!isCurriculumDP ||
              (isCurriculumDP && _.isEmpty(subjectLevelGenericTags)) ? (
                <div className={percentageWeightContainerClass}>
                  <div className={percentageWeightInputClasses}>
                    <TextInput
                      placeholder="Eg. 20"
                      value={percentage_weight}
                      required={true}
                      onChange={e => updateWeight("percentage_weight", e)}
                      error={
                        _.get(
                          areNotValid,
                          `percentage_weight_${index}`,
                          false
                        ) && !percentage_weight
                      }
                      dsVersion={dsVersion}
                    />
                  </div>
                  {!isAbsoluteWeightageType &&
                    !isNewAssessmentSettingsEnabled && (
                      <span className={classes.percentageContainer}>%</span>
                    )}
                  {isNewAssessmentSettingsEnabled && (
                    <div className={percentageWeightInputClasses}>
                      <TextInput
                        placeholder="Eg. 20%"
                        value={getAbsolutePercentageValueMemoize({
                          key: "percentage_weight",
                          fieldValues,
                          value: percentage_weight,
                        })}
                        required={false}
                        disabled={true}
                        dsVersion={dsVersion}
                      />
                    </div>
                  )}
                </div>
              ) : (
                <>
                  {_.map(subjectLevelGenericTags, tag => {
                    const tagLabel = _.get(tag, "label", "");
                    const key = _.isEqual(tagLabel, "SL")
                      ? "slWeight"
                      : "hlWeight";
                    const weight = _.isEqual(tagLabel, "SL")
                      ? slWeight
                      : hlWeight;

                    return (
                      <div className={percentageWeightContainerClass}>
                        <div className={percentageWeightInputClasses}>
                          <TextInput
                            placeholder="Eg. 20"
                            value={weight}
                            required={true}
                            onChange={e => updateWeight(key, e)}
                            error={
                              _.get(
                                areNotValid,
                                `${_.toLower(tagLabel)}_weight_${index}`,
                                false
                              ) && !weight
                            }
                            dsVersion={dsVersion}
                          />
                        </div>
                        {!isAbsoluteWeightageType &&
                          !isNewAssessmentSettingsEnabled && (
                            <span className={classes.percentageContainer}>
                              %
                            </span>
                          )}
                        {isNewAssessmentSettingsEnabled && (
                          <div className={percentageWeightInputClasses}>
                            <TextInput
                              placeholder="Eg. 20%"
                              value={getAbsolutePercentageValueMemoize({
                                key,
                                fieldValues,
                                value: weight,
                              })}
                              required={false}
                              disabled={true}
                              dsVersion={dsVersion}
                            />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </>
              ))}
            {canDefineGradeBoundary &&
              isShowGradeBoundaries &&
              (gradeBoundaryId || !_.isEmpty(gradeScaleType) ? (
                <div className={gradeBoundaryAddedClasses}>
                  <div className={classes.buttonContainer} onClick={openModal}>
                    <TickCircleFilled variant="subtle" size="xx-small" />
                    <div className={addedTextClass}>{t("common:added")}</div>
                  </div>
                  <div className={classes.dropdownContainer}>
                    <Dropdown
                      getPopupContainer={el => {
                        return el;
                      }}
                      overlay={
                        <DropdownMenu
                          onClick={e => {
                            e.domEvent.stopPropagation();
                            const action = e.key;
                            onClickDropdownMenu({
                              action,
                              modalParams: modalParamsObj,
                            });
                          }}
                          options={dropdownOptions}
                          dsVersion={dsVersion}
                        />
                      }
                      placement={"bottomRight"}
                      dsVersion={dsVersion}
                    >
                      <IconButton
                        onClick={e => {
                          e.stopPropagation();
                        }}
                        icon={
                          <DotsVerticalOutlined
                            variant="subtle"
                            size="xx-small"
                          />
                        }
                        _legacy_variant="plain"
                        variant="neutral"
                        type="plain"
                        dsVersion={dsVersion}
                        size={showUpdatedDesign ? "small" : "medium"}
                      />
                    </Dropdown>
                  </div>
                </div>
              ) : (
                <div className={gradeBoundaryBtnClasses}>
                  <Button
                    _legacy_size="large"
                    size="medium"
                    _legacy_variant="plain"
                    type="plain"
                    variant="neutral"
                    icon={<AddOutlined variant="subtle" />}
                    onClick={openModal}
                    disabled={addGradeScaleBtnDisabled}
                    dsVersion={dsVersion}
                  >
                    {t("common:add")}
                  </Button>
                </div>
              ))}
          </div>
          {_.size(fieldValues) > 1 ? (
            <div className={deleteBtnClasses}>
              <IconButton
                icon={<DeleteOutlined variant="subtle" />}
                id="icon-button"
                size="medium"
                _legacy_variant="outlined-subtle"
                variant="neutral"
                type={showUpdatedDesign ? "plain" : "outlined"}
                onClick={onClickDelete}
                dsVersion={dsVersion}
              />
            </div>
          ) : null}
        </div>
      </div>
    );
  };

  const percentageWeightClass = classNames({
    [classes.warningText]: totalPercentageWeight?.percentage_weight !== 100,
    [classes.percentageWeightText]:
      totalPercentageWeight?.percentage_weight === 100,
  });

  const percentageSLWeightClass = classNames({
    [classes.warningText]: totalPercentageWeight?.slWeight !== 100,
    [classes.percentageWeightText]: totalPercentageWeight?.slWeight === 100,
  });

  const percentageHLWeightClass = classNames({
    [classes.warningText]: totalPercentageWeight?.hlWeight !== 100,
    [classes.percentageWeightText]: totalPercentageWeight?.hlWeight === 100,
  });

  const categorySetGradeContainerClass = classNames({
    [classes.categorySetGradeContainer]:
      isClassSettingsContext || (isScoreV2 && isCurriculumDP),
  });

  const templateNameTextInputContainerClass = classNames({
    [classes.templateNameTextInputContainer]: !showUpdatedDesign,
    [classes.fieldContainer]: isScoreV2,
    [classes.fieldContainerForModal]: isClassSettingsContext,
    [classes.templateNameTextInputContainerV2]: showUpdatedDesign,
  });

  const gradeSelectDropdownContainerClass = classNames({
    [classes.gradeSelectDropdownContainer]: !showUpdatedDesign,
    [classes.fieldContainer]: isScoreV2 && isCurriculumDP,
    [classes.fieldContainerForModal]: isClassSettingsContext,
    [classes.gradeSelectDropdownContainerV2]: showUpdatedDesign,
  });

  const defineGradeBoundariesLabelClass = classNames({
    [classes.defineGradeBoundariesLabel]: !showUpdatedDesign,
    ["text-label-2"]: !showUpdatedDesign,
    ["text-label"]: showUpdatedDesign,
    [classes.defineGradeBoundariesLabelV2]: showUpdatedDesign,
  });

  const onClickDone = () => {
    deleteTemplateFieldValue({ index: deleteCategoryConfirmation?.index });
    setDeleteCategoryConfirmation({});
  };

  const updateSelectedGrades = selectedGrades => {
    const selectedGradeIds = _.map(
      isScoreV2 ? [selectedGrades] : selectedGrades,
      ({ value }) => value
    );

    updateTemplateFieldsSet({ courses: selectedGradeIds });
  };

  const getGradeBoundariesTooltipText = () => {
    if (isCurriculumUBD || finalGradeCalculationMethod === SCORE) {
      return t("academicSetup:define_category_grade_boundary_tooltip_text");
    } else {
      return t(
        "academicSetup:assign_grade_boundary_for_each_category_tooltip_text"
      );
    }
  };

  const onClickConfirm = async () => {
    switch (currentDialogueInfo?.action) {
      case "DELETE":
        currentDialogueInfo?.params?.onClickDelete?.();
        setCurrentDialogueInfo({});
    }
  };

  const currentDialogueInfoAction = currentDialogueInfo?.action;

  const categoryContainerStyle = classNames({
    [classes.categoryContainer]: !showUpdatedDesign,
    [classes.categoryContainerForClassSettinginUBD]:
      !showUpdatedDesign && !isCurriculumDP && isClassSettingsContext,
    [classes.categoryContainerForClassSettinginDP]:
      !showUpdatedDesign && isCurriculumDP && isClassSettingsContext,
    [classes.categoryContainerForScoreCalculationType]:
      !showUpdatedDesign && isNewAssessmentSettingsEnabled,
    [classes.categoryContainerV2]: showUpdatedDesign,
    [classes.categoryContainerForScoreCalculationTypeV2]:
      showUpdatedDesign && isNewAssessmentSettingsEnabled,
  });

  const categoryHeaderTextStyle = classNames({
    [classes.categoryHeaderText]: !showUpdatedDesign,
    [classes.categoryHeaderTextForClassSettinginUBD]:
      !showUpdatedDesign && !isCurriculumDP && isClassSettingsContext,
    [classes.categoryHeaderTextForScoreCalculationType]: isNewAssessmentSettingsEnabled,
    ["text-label"]: showUpdatedDesign,
    [classes.categoryHeaderTextV2]: showUpdatedDesign,
  });

  const categoryTemplateHeaderStyle = classNames({
    [classes.categoryTemplateHeader]: !showUpdatedDesign,
    [classes.categoryTemplateHeaderForClassSettinginUBD]:
      !showUpdatedDesign && !isCurriculumDP && isClassSettingsContext,
    [classes.categoryTemplateHeaderV2]: showUpdatedDesign,
  });

  const categoryWeightTextClass = classNames({
    [classes.categoryWeightText]: !showUpdatedDesign,
    [classes.categoryWeightTextForScoreCalculationType]:
      !showUpdatedDesign && isNewAssessmentSettingsEnabled,
    ["text-label"]: showUpdatedDesign,
    [classes.categoryWeightTextV2]: showUpdatedDesign,
  });

  const gradeBoundaryClass = classNames({
    [classes.categoryWeightText]: !showUpdatedDesign,
    [classes.gradeBoundaryForScoreCalculationType]:
      !showUpdatedDesign && isNewAssessmentSettingsEnabled,
    ["text-label"]: showUpdatedDesign,
    [classes.categoryGradeBoundary]: showUpdatedDesign,
  });

  const gradeBoundaryModalParams = {
    t,
    termId,
    subjectId,
    subjectType,
    ...modalParams,
    templateFieldsObj,
    curriculumProgramId,
    defaultGradeScaleSet,
    setIsTemplateUpdated,
    subjectLevelGenericTags,
    closeModal: () => setModalParams({}),
    currentCategoryGradeBoundaryValues,
    overallCategoryGradeBoundaryValues,
    updateCurrentCategoryGradeBoundaryValues,
    updateOverallCategoryGradeBoundaryValues,
    portalType,
    showUpdatedDesign,
  };

  const categoryGradeBoundaryToggleTooltip = getCategoryGradeBoundaryToggleTooltip(
    { isAdmin, finalGradeCalculationMethod, t }
  );

  const noGradeCalculationMethodSelected =
    _.isEmpty(finalGradeCalculationMethod) || _.isEmpty(gradeCalculationMethod);

  const dropDownLabelClasses = classNames({
    [classes.dropDownLabel]: !showUpdatedDesign,
    ["text-label"]: showUpdatedDesign,
    [classes.dropDownLabelV2]: showUpdatedDesign,
  });

  const defineGradeBoundariesClasses = classNames({
    [classes.defineGradeBoundaries]: !showUpdatedDesign,
    [classes.defineGradeBoundariesV2]: showUpdatedDesign,
  });

  return (
    <>
      <div className={classes.container}>
        {isClassSettingsContext ? (
          <div className={classes.alertContainer}>
            <Alert message={alertText} type="warning" dsVersion={dsVersion} />
          </div>
        ) : null}
        {!isClassSettingsContext ? (
          <div className={classes.headerContainer}>
            <div>
              {!isScoreV2 && (
                <BreadCrumbs
                  hierarchy={getHierarchy({
                    slice: 4,
                    subjectId,
                    subjectName,
                    t,
                    curriculumProgramTitle,
                  })}
                  onHierarchyClick={({ id }) => {
                    goToRelativeRoute({
                      route: getHierarchyRoute({
                        id,
                        curriculumType,
                        curriculumProgramId,
                      }),
                      type: "replace",
                      replacePath: "administrator",
                    });
                  }}
                />
              )}
              <div className={classes.headerText}>
                {isEditMode
                  ? t("classRoom:edit_category_set")
                  : t("classRoom:add_category_set")}
              </div>
              <div className={classes.headerSubText}>
                {isScoreV2
                  ? t("academicSetup:category_set_header_subtext_label", {
                      label: subjectName,
                    })
                  : t("academicSetup:category_set_header_subtext")}
              </div>
            </div>
            {renderHeadingRightContainer}
          </div>
        ) : null}
        <div className={classes.bodyContainer}>
          <div className={categorySetGradeContainerClass}>
            <div className={templateNameTextInputContainerClass}>
              <TextInput
                label={`${t("academicSetup:category_set_title")}*`}
                placeholder={t("academicSetup:enter_category_set_title")}
                size={showUpdatedDesign ? "medium" : "large"}
                value={label}
                required={true}
                onChange={e =>
                  updateTemplateFieldsSet({ label: e.target.value })
                }
                error={_.get(areNotValid, "setLabel", false) && !label}
                dsVersion={dsVersion}
              />
            </div>
            <div className={gradeSelectDropdownContainerClass}>
              {!isCourseApplicableToCategorySet ? (
                <>
                  <div className={dropDownLabelClasses}>
                    {isScoreV2
                      ? `${t("academicSetup:applicable_grade")}*`
                      : `${t("academicSetup:applicable_grades_small")}*`}
                  </div>
                  <SelectDropdown
                    name={"grades"}
                    placeholder={
                      isScoreV2
                        ? t("community:select_grade")
                        : t("common:select_grades_placeholder")
                    }
                    onChange={updateSelectedGrades}
                    options={getGradesOptionsMemoize({
                      grades,
                      usedCourses,
                    })}
                    value={getSelectedGradesMemoize({
                      grades,
                      templateFieldsObj,
                    })}
                    isMulti={!isScoreV2}
                    size={showUpdatedDesign ? "medium" : "large"}
                    noOptionsText={t("common:no_grades")}
                    error={
                      _.get(areNotValid, `courses`, false) && _.isEmpty(courses)
                    }
                    isClearable={false}
                    isDisabled={isClassSettingsContext}
                    dsVersion={dsVersion}
                  />
                </>
              ) : (
                <>
                  <div className={dropDownLabelClasses}>
                    {t("common:applicable_classes")}
                  </div>
                  <div className={classes.inputField}>
                    <SelectDropdownButton
                      name="courses"
                      placeholder={t("common:select_class_plural")}
                      checkboxGroupName={t("common:classes")}
                      options={getCourseOptionsMemoize({
                        subjectBasedCourses,
                        organizationPointSet,
                        templateFieldsObj,
                        t,
                      })}
                      updateInputField={updateTemplateFieldsSet}
                      value={courses}
                      error={
                        _.get(areNotValid, `courses`, false) &&
                        _.isEmpty(courses)
                      }
                      disabledList={usedCourses}
                      tooltipPosition={"top"}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
          {showCategoryGradeBoundaryToggle ? (
            <div className={defineGradeBoundariesClasses}>
              <ConditionalWrapper
                wrapper={
                  <Tooltip
                    tooltip={categoryGradeBoundaryToggleTooltip}
                    placement="bottom"
                    showArrow={true}
                    dsVersion={dsVersion}
                  />
                }
                condition={noGradeCalculationMethodSelected}
                type={"wrapperAsElement"}
              >
                <ToggleSwitch
                  checked={isShowGradeBoundaries}
                  onChange={e =>
                    updateTemplateFieldsSet({
                      isShowGradeBoundaries: e.target.checked,
                    })
                  }
                  disabled={noGradeCalculationMethodSelected}
                  dsVersion={dsVersion}
                  size={showUpdatedDesign ? "medium" : "large"}
                  _legacy_size={"x-small"}
                />
              </ConditionalWrapper>
              <div className={defineGradeBoundariesLabelClass}>
                {getCategoryGradeBoundaryToggleLabel({
                  t,
                  isCurriculumUBD,
                  finalGradeCalculationMethod,
                })}
              </div>
              <Tooltip
                tooltip={getGradeBoundariesTooltipText()}
                overlayInnerStyle={styles.tooltipStyle}
                showArrow={true}
                dsVersion={dsVersion}
              >
                <InformationFilled variant="subtle" size="xx-small" />
              </Tooltip>
            </div>
          ) : null}

          <div>
            <div className={categoryTemplateHeaderStyle}>
              <div className={categoryHeaderTextStyle}>
                {t("academicSetup:assessment_categories")}
              </div>
              {isWeightageEnabledForCategory &&
                (!isCurriculumDP ||
                (isCurriculumDP && _.isEmpty(subjectLevelGenericTags)) ? (
                  <div className={categoryContainerStyle}>
                    <div className={categoryWeightTextClass}>
                      {isNewAssessmentSettingsEnabled
                        ? t("common:weight")
                        : isAbsoluteWeightageType
                        ? t("academicSetup:absolute_weight")
                        : "%"}
                    </div>
                    {isNewAssessmentSettingsEnabled && (
                      <div className={categoryWeightTextClass}>%</div>
                    )}
                    {!isAbsoluteWeightageType &&
                      !isNewAssessmentSettingsEnabled && (
                        <div className={percentageWeightClass}>
                          {checkTotalPercentageWeightError({
                            totalPercentageWeight:
                              totalPercentageWeight?.percentage_weight,
                            t,
                          })}
                        </div>
                      )}
                  </div>
                ) : (
                  <>
                    {_.map(subjectLevelGenericTags, tag => {
                      const tagLabel = _.get(tag, "label", "");
                      const categoryWeightText = isNewAssessmentSettingsEnabled
                        ? `${t("common:weight")} (${tagLabel})`
                        : isAbsoluteWeightageType
                        ? t(
                            `academicSetup:absolute_weight_${_.toLower(
                              tagLabel
                            )}`
                          )
                        : t(
                            `academicSetup:percentage_weight_${_.toLower(
                              tagLabel
                            )}`
                          );
                      const percentageWeight = _.isEqual(tagLabel, "SL")
                        ? totalPercentageWeight?.slWeight
                        : totalPercentageWeight?.hlWeight;
                      const errorTextClass = _.isEqual(tagLabel, "SL")
                        ? percentageSLWeightClass
                        : percentageHLWeightClass;

                      return (
                        <div className={categoryContainerStyle}>
                          <div className={categoryWeightTextClass}>
                            {categoryWeightText}
                          </div>
                          {isNewAssessmentSettingsEnabled && (
                            <div className={categoryWeightTextClass}>
                              {`% (${tagLabel})`}
                            </div>
                          )}
                          {!isAbsoluteWeightageType &&
                            !isNewAssessmentSettingsEnabled && (
                              <div className={errorTextClass}>
                                {checkTotalPercentageWeightError({
                                  totalPercentageWeight: percentageWeight,
                                  t,
                                })}
                              </div>
                            )}
                        </div>
                      );
                    })}
                  </>
                ))}
              {isScoreV2 && isShowGradeBoundaries && canDefineGradeBoundary && (
                <div className={categoryContainerStyle}>
                  <div className={gradeBoundaryClass}>
                    {t("academicSetup:grade_boundary")}
                  </div>
                </div>
              )}
            </div>
          </div>
          {_.map(fieldValues, (fieldValue, index) =>
            renderCategoryInput({
              fieldValue,
              index,
              isLastCategory: index === fieldValuesLength - 1,
            })
          )}
        </div>
        <div
          className={isClassSettingsContext ? classes.addCategoryButton : null}
        >
          <Button
            icon={<AddCircleOutlined />}
            size="medium"
            _legacy_size="large"
            _legacy_variant="inline-progressive"
            variant="progressive"
            type="inline"
            onClick={() => addTemplateFieldValue()}
            dsVersion={dsVersion}
            style={styles.addCategoryButton}
          >
            {t("common:add_category")}
          </Button>
        </div>
      </div>
      {isLoading ? (
        <FullScreenLoader
          overlayContainer={classes.fullScreenLoaderOverlayContainer}
        />
      ) : null}

      {isEditMode && !_.isEmpty(deleteCategoryConfirmation) ? (
        <AssessmentCategoriesDeleteModal
          itemId={deleteCategoryConfirmation?.categoryId}
          itemLabel={deleteCategoryConfirmation?.label}
          closeModal={() => setDeleteCategoryConfirmation({})}
          onClickDelete={() => onClickDone()}
          itemType={"INDIVIDUAL_CATEGORY"}
          portalType={portalType}
          showUpdatedDesign={showUpdatedDesign}
        />
      ) : null}

      {!_.isEmpty(modalParams) &&
        (isCurriculumDP || isCurriculumMYP ? (
          <CategoryGradeBoundary {...gradeBoundaryModalParams} />
        ) : (
          <CategoryGradeScale {...gradeBoundaryModalParams} />
        ))}

      {!_.isEmpty(currentDialogueInfoAction) ? (
        <Modal
          shouldCloseOnEsc={true}
          shouldCloseOnOverlayClick={true}
          hasOverlay={true}
          width="480px"
          height={"fit-content"}
          onClose={() => setCurrentDialogueInfo({})}
        >
          <Modal.Header
            title={DIALOGS_INFO[currentDialogueInfoAction]?.title({
              t,
              currentDialogueInfo,
            })}
          />
          <Modal.Body isScrollable={true}>
            {DIALOGS_INFO[currentDialogueInfoAction]?.body({
              t,
              currentDialogueInfo,
              setCurrentDialogueInfo,
              curriculumProgramId,
              curriculumType,
              openLinkInNewTab,
              getAssessmentObj,
            })}
          </Modal.Body>
          <Modal.Footer>
            <footer className={classes.footer}>
              <Button
                _legacy_size="large"
                size="medium"
                _legacy_variant={"outlined-subtle"}
                variant="neutral"
                type="outlined"
                onClick={() => setCurrentDialogueInfo({})}
              >
                {DIALOGS_INFO[currentDialogueInfoAction]?.cancelButtonText({
                  t,
                })}
              </Button>
              <Button
                _legacy_size="large"
                size="medium"
                disabled={DIALOGS_INFO[
                  currentDialogueInfoAction
                ]?.disableConfirmButton({
                  currentDialogueInfo,
                })}
                onClick={onClickConfirm}
              >
                {DIALOGS_INFO[currentDialogueInfoAction]?.confirmButtonText({
                  t,
                })}
              </Button>
            </footer>
          </Modal.Footer>
        </Modal>
      ) : null}
    </>
  );
};

const mapActionCreators = {
  openLinkInNewTab,
  getAssignmentsWithAutoEvaluateTool,
  getAssessmentObj,
};

export default connect(null, mapActionCreators)(CreateTemplate);
